import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

interface RedirectAfterLoginProps {
  fallback?: string,
}

/**
 * Catch-all for authenticated users: send them to the `redirect` page captured
 * before login (see RedirectToLogin), falling back to the home page. Only
 * internal absolute paths are honored to avoid open-redirects.
 */
const RedirectAfterLogin = ({ fallback = '/' }: RedirectAfterLoginProps) => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');
  const decoded = redirect ? decodeURIComponent(redirect) : undefined;
  const isSafe = !!decoded && decoded.startsWith('/') && !decoded.startsWith('//');
  return <Navigate to={isSafe ? decoded! : fallback} replace />;
};

export default RedirectAfterLogin;
